<template>
  <div class="platform-container">
    <!-- 左上角返回按钮区域 -->
    <div class="back-area" @click="goBack"></div>
    
    <!-- 右下角切换图片区域 -->
    <div class="switch-area" @click="switchImage"></div>
    
    <img 
      :src="currentImage" 
      alt="朝阳区人事考试智能指挥调度一体化平台" 
      class="platform-image"
    />
  </div>
</template>

<script>
export default {
  name: 'Platform',
  data() {
    return {
      currentImage: require('./img1.png'), // 当前显示的图片，使用require导入
    };
  },
  mounted() {
    // 页面加载完成后设置全屏
    this.enterFullscreen();
  },
  beforeDestroy() {
    // 页面销毁前退出全屏
    this.exitFullscreen();
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    
    // 切换图片
    switchImage() {
      if (this.currentImage === require('./img1.png')) {
        this.currentImage = require('./img2.png');
      } else {
        this.currentImage = require('./img1.png');
      }
    },
    
    // 进入全屏
    enterFullscreen() {
      const element = document.documentElement;
      try {
        if (element.requestFullscreen) {
          element.requestFullscreen().catch(err => {
            console.log('进入全屏失败:', err);
          });
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      } catch (err) {
        console.log('全屏API调用失败:', err);
      }
    },
    
    // 退出全屏
    exitFullscreen() {
      // 检查是否处于全屏状态
      if (document.fullscreenElement || 
          document.mozFullScreenElement || 
          document.webkitFullscreenElement || 
          document.msFullscreenElement) {
        
        if (document.exitFullscreen) {
          document.exitFullscreen().catch(err => {
            console.log('退出全屏失败:', err);
          });
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.platform-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
  overflow: hidden;
  position: relative;
}

.platform-image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

// 左上角返回区域
.back-area {
  position: absolute;
  top: 0;
  left: 0;
  width: 150px;
  height: 150px;
  z-index: 10;
  cursor: pointer;
  // 调试时可以添加背景色查看区域
  // background-color: rgba(255, 0, 0, 0.3);
}

// 右下角切换图片区域
.switch-area {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 150px;
  height: 150px;
  z-index: 10;
  cursor: pointer;
  // 调试时可以添加背景色查看区域
  // background-color: rgba(0, 255, 0, 0.3);
}
</style>